import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const AgentCorporateReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Agent / Corporate Booking"
    description="Bookings and revenue grouped by agent, corporate or rate plan."
    icon={<IconSystem.user size={18} />}
    phaseLabel="Coming in Phase 5"
    comingSoonHint="Top contributors by net revenue, room nights and ADR; supports drill-down."
  />
);
export default AgentCorporateReportScreen;
